import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [station, setStation] = useState(null);
  const [node, setNode] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Load session from localStorage
    const savedUser = localStorage.getItem('currentUser');
    const savedStation = localStorage.getItem('currentStation');
    const savedNode = localStorage.getItem('currentNode');
    
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    if (savedStation) {
      setStation(JSON.parse(savedStation));
    }
    if (savedNode) {
      setNode(JSON.parse(savedNode));
    }
    
    setIsLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('currentUser', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setStation(null);
    setNode(null);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentStation');
    localStorage.removeItem('currentNode');
  };

  const selectStation = (stationData) => {
    setStation(stationData);
    setNode(null); // Clear node when changing station
    localStorage.setItem('currentStation', JSON.stringify(stationData));
    localStorage.removeItem('currentNode');
  };

  const selectNode = (nodeData) => {
    setNode(nodeData);
    localStorage.setItem('currentNode', JSON.stringify(nodeData));
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      station,
      node,
      isLoading,
      login, 
      logout, 
      selectStation,
      selectNode
    }}>
      {children}
    </AuthContext.Provider>
  );
};
